import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import ExcelReport from "../types/excelReport";

interface ReportState {
  status: "idle" | "loading" | "failed";
}

const initialState: ReportState = {
  status: "idle",
};

export const excelReport = createAsyncThunk<boolean, ExcelReport>(
  "report/excel",
  async (report: ExcelReport) => {
    const response = await http.post<Blob>(`/report/excel`, report, {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "DetectorReport.xlsx");
    document.body.appendChild(link);
    link.click();
    return true;
  }
);

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(excelReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(excelReport.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(excelReport.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default reportSlice.reducer;
